<a
  (click)="chatClick()"
  [ngClass]="isLiveChatAvailable ? 'online' : 'offline'"
  *ngIf="!loading"
>
  Live Chat
  <ng-container *ngIf="isLiveChatAvailable">
    (Online
    <span class="dot green-dot" title="Live Chat Online"></span>)
  </ng-container>
  <ng-container *ngIf="!isLiveChatAvailable">
    (Offline
    <span class="dot red-dot" title="Live Chat Offline"></span>)
  </ng-container>
</a>
<p *ngIf="loading" class="loading-chat">Loading Live Chat...</p>
